<app-navbar></app-navbar>

<div class="container mt-4">

    <div class="card-custom shadow-sm mb-4">

        <div class="card-body">

            <div class="d-flex justify-content-between align-items-center mb-4">

                <h3>

                    <i class="fa-solid fa-clipboard-check"></i>

                    Trend SFGE

                </h3>

                <button class="btn btn-sm btn-outline-primary-custom" (click)="goBack()">

                    <i class="fa-solid fa-arrow-left"></i>

                    Indietro

                </button>

            </div>

            <!-- HEADER PAZIENTE SMART -->
            <app-patientsmart-header [patient]="patient" [accessiCount]="accessiCount">

            </app-patientsmart-header>

            <div *ngIf="sfgeList.length > 0" class="alert alert-gradient-senior mb-4">

                <div class="row text-center">

                    <div class="col">

                        <small>Ultimo Score</small>

                        <h4 class="text-white">

                            {{ sfgeList[0].punteggioTotale }}

                        </h4>

                    </div>

                    <div class="col">

                        <small>Classe Attuale</small>

                        <h5>

                            {{ sfgeList[0].classeRischio }}

                        </h5>

                    </div>

                    <div class="col">

                        <small>Valutazioni</small>

                        <h5>

                            {{ sfgeList.length }}

                        </h5>

                    </div>

                </div>

            </div>

            <div class="sfge-timeline">

                <div *ngFor="let item of sfgeList; let last = last" class="sfge-timeline-item">

                    <div class="sfge-timeline-marker">

                        <div class="sfge-timeline-dot" [ngClass]="{
          'bg-success':
            item.classeRischio === 'Robusto',

          'bg-info':
            item.classeRischio === 'Pre-Fragile',

          'bg-warning':
            item.classeRischio === 'Fragile',

          'bg-danger':
            item.classeRischio === 'Molto Fragile'
        }">
                        </div>

                        <div *ngIf="!last" class="sfge-timeline-line">
                        </div>

                    </div>

                    <div class="sfge-timeline-content">

                        <div class="d-flex justify-content-between align-items-center">

                            <div>

                                <h6 class="mb-1">

                                    {{ item.dataAccesso
                                    | date:'dd/MM/yyyy' }}

                                </h6>

                                <small class="text-muted">

                                    {{ item.tipoAccesso }}

                                </small>

                            </div>

                            <strong>

                                {{ item.classeRischio }}

                            </strong>

                            <span class="badge" [ngClass]="sfgeHelper.getClasseRischioColor(item.classeRischio)">

                                Score {{ item.punteggioTotale }}

                            </span>

                        </div>

                        <hr>

                        <div class="d-flex gap-2">

                            <button class="btn btn-primary-custom-sm" (click)="toggleRiepilogo(item.idSfge)">

                                <i class="fa-solid fa-eye"></i>

                                {{
                                expandedSfgeId === item.idSfge
                                ? 'Nascondi'
                                : 'Vedi riepilogo'
                                }}

                            </button>

                            <button class="btn btn-primary-custom-sm" [routerLink]="['/sfge', item.idAccesso]">

                                <i class="fa-solid fa-pen"></i>

                                Modifica

                            </button>

                        </div>

                        <div *ngIf="expandedSfgeId === item.idSfge" class="card-custom shadow-sm mt-3">

                            <div class="card-body">

                                <h5 class="mb-4">

                                    <i class="fa-solid fa-list-check"></i>

                                    Riepilogo SFGE

                                </h5>

                                <div class="row">

                                    <!-- COLONNA SINISTRA -->

                                    <div class="col-md-6">

                                        <table class="table table-sm">

                                            <tbody>

                                                <tr>
                                                    <td>Età</td>
                                                    <td>{{ sfgeHelper.getEtaDescription(selectedSfge.eta) }}</td>
                                                    <td class="text-end">{{ selectedSfge.eta }}</td>
                                                </tr>

                                                <tr>
                                                    <td>Formazione</td>
                                                    <td>{{ sfgeHelper.getFormazioneDescription(selectedSfge.formazione)
                                                        }}</td>
                                                    <td class="text-end">{{ selectedSfge.formazione }}</td>
                                                </tr>

                                                <tr>
                                                    <td>Conviventi</td>
                                                    <td>{{ sfgeHelper.getConviventiDescription(selectedSfge.conviventi, selectedSfge.tipoConvivente)
                                                        }}</td>
                                                    <td class="text-end">{{ selectedSfge.conviventi }}</td>
                                                </tr>

                                                <tr *ngIf="selectedSfge.conviventi === -1">
                                                    <td>Età coniuge</td>
                                                    <td>{{ sfgeHelper.getEtaConiugeDescription(selectedSfge.ietaConiuge)
                                                        }}</td>
                                                    <td class="text-end">{{ selectedSfge.ietaConiuge }}</td>
                                                </tr>

                                                <tr>
                                                    <td>Aiuto necessità</td>
                                                    <td>{{ sfgeHelper.getAiutoDescription(selectedSfge.aiutoNecessita)
                                                        }}</td>
                                                    <td class="text-end">{{ selectedSfge.aiutoNecessita }}</td>
                                                </tr>

                                                <tr>
                                                    <td>Attività sociali</td>
                                                    <td>{{
                                                        sfgeHelper.getAttivitaDescription(selectedSfge.attivitaSociali)
                                                        }}
                                                    </td>
                                                    <td class="text-end">{{ selectedSfge.attivitaSociali }}</td>
                                                </tr>

                                                <tr>
                                                    <td>Servizi sociali</td>
                                                    <td>{{
                                                        sfgeHelper.getServiziDescription(selectedSfge.assistenzaServizi)
                                                        }}
                                                    </td>
                                                    <td class="text-end">{{ selectedSfge.assistenzaServizi }}</td>
                                                </tr>

                                                <tr>
                                                    <td>Situazione economica</td>
                                                    <td>{{
                                                        sfgeHelper.getSituazioneEconomicaDescription(selectedSfge.situazioneEconomica)
                                                        }}</td>
                                                    <td class="text-end">{{ selectedSfge.situazioneEconomica }}</td>
                                                </tr>

                                                <tr *ngIf="selectedSfge.problemiEconomici !== null">
                                                    <td>Problemi economici</td>
                                                    <td>{{
                                                        sfgeHelper.getProblemiEconomiciDescription(selectedSfge.problemiEconomici)
                                                        }}</td>
                                                    <td class="text-end">{{ selectedSfge.problemiEconomici }}</td>
                                                </tr>

                                            </tbody>

                                        </table>

                                    </div>

                                    <!-- COLONNA DESTRA -->

                                    <div class="col-md-6">

                                        <table class="table table-sm">

                                            <tbody>

                                                <tr>
                                                    <td>Energia</td>
                                                    <td>{{
                                                        sfgeHelper.getEnergiaDescription(selectedSfge.energiaMotivazione)
                                                        }}
                                                    </td>
                                                    <td class="text-end">{{ selectedSfge.energiaMotivazione }}</td>
                                                </tr>

                                                <tr>
                                                    <td>Bagno autonomo</td>
                                                    <td>{{ sfgeHelper.getBagnoDescription(selectedSfge.bagnoAutonomo) }}
                                                    </td>
                                                    <td class="text-end">{{ selectedSfge.bagnoAutonomo }}</td>
                                                </tr>

                                                <tr>
                                                    <td>Esce di casa</td>
                                                    <td>{{ sfgeHelper.getEsceCasaDescription(selectedSfge.esceCasa) }}
                                                    </td>
                                                    <td class="text-end">{{ selectedSfge.esceCasa }}</td>
                                                </tr>

                                                <tr>
                                                    <td>Allettato</td>
                                                    <td>{{ sfgeHelper.getAllettatoDescription(selectedSfge.allettato) }}
                                                    </td>
                                                    <td class="text-end">{{ selectedSfge.allettato }}</td>
                                                </tr>

                                                <tr>
                                                    <td>Confuso</td>
                                                    <td>{{ sfgeHelper.getConfusoDescription(selectedSfge.confuso) }}
                                                    </td>
                                                    <td class="text-end">{{ selectedSfge.confuso }}</td>
                                                </tr>

                                                <tr>
                                                    <td>Farmaci</td>
                                                    <td>{{ sfgeHelper.getFarmaciDescription(selectedSfge.farmaci) }}
                                                    </td>
                                                    <td class="text-end">{{ selectedSfge.farmaci }}</td>
                                                </tr>

                                                <tr>
                                                    <td>Cadute</td>
                                                    <td>{{ sfgeHelper.getCaduteDescription(selectedSfge.cadute) }}</td>
                                                    <td class="text-end">{{ selectedSfge.cadute }}</td>
                                                </tr>

                                                <tr>
                                                    <td>Ricoveri</td>
                                                    <td>{{ sfgeHelper.getRicoveriDescription(selectedSfge.ricoveri) }}
                                                    </td>
                                                    <td class="text-end">{{ selectedSfge.ricoveri }}</td>
                                                </tr>

                                            </tbody>

                                        </table>

                                    </div>

                                </div>

                                <hr>

                                <div class="d-flex justify-content-between align-items-center">

                                    <strong>Punteggio Totale</strong>

                                    <span class="badge bg-primary-custom fs-6">

                                        {{ item.punteggioTotale }}

                                    </span>

                                </div>

                                <div class="card border-0 bg-light mt-3">

                                    <div class="card-body">

                                        <h5>

                                            Classe di rischio

                                        </h5>

                                        <span class="badge fs-6 mb-3" [ngClass]="
            sfgeHelper.getClasseRischioColor(
              item.classeRischio
            )
          ">

                                            {{ item.classeRischio }}

                                        </span>

                                        <h6>

                                            <i class="fa-solid fa-circle-info text-primary-custom me-1"></i>

                                            Interpretazione

                                        </h6>

                                        <div class="mt-2">

                                            {{ sfgeHelper.getInterpretazione(item.classeRischio) }}

                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>

            </div>

            <div *ngIf="sfgeList.length > 1" class="alert alert-info-custom mt-4">

                <strong>

                    Variazione complessiva:

                </strong>

                {{ getDelta() }}

                punti

            </div>


            <!-- grafico -->

        </div>
    </div>

    <div *ngIf="sfgeList.length > 1" class="card-custom shadow-sm mt-4 mb-4">

        <div class="card-body">

            <h5 class="mb-4">

                <i class="fa-solid fa-chart-line"></i>

                Grafico SFGE

            </h5>

            <div class="row text-center alert-gradient-senior mb-3">

                <div class="col-md-4">

                    <small class="text-white">

                        Primo Score

                    </small>

                    <h5>

                        {{ firstScore }}

                    </h5>

                </div>

                <div class="col-md-4">

                    <small class="text-white">
                        Ultimo Score

                    </small>

                    <h5>

                        {{ lastScore }}

                    </h5>

                </div>

                <div class="col-md-4">

                    <small class="text-white">

                        Trend

                    </small>

                    <h5>

                        {{ getTrendDescription() }}

                    </h5>

                </div>

            </div>

            <canvas id="sfgeChart">

            </canvas>

        </div>

    </div>



</div>